import { render, staticRenderFns } from "./TournamentRefereePanel.vue?vue&type=template&id=53a90a5c&"
import script from "./TournamentRefereePanel.vue?vue&type=script&lang=js&"
export * from "./TournamentRefereePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports